<template>
	<div class="quote-box" ref="quoteBox">
		<QuoteHeader ref="quoteHeaderRef" :stockQuoteData="stockQuoteData" @toggleInfo="handleToggleInfo" />
		<div class="echart-wrap">
			<div class="k-line-tab">
				<TableTab
					:tabList="kLineTabList"
					:activeValue="kLineActValue"
					@change="item => changeTab(item.value)"
				/>
			</div>
			<KChart v-if="isKType" class="stock-box-chat" :time="kLineActValue" />
			<MkChart v-else ref="refAbbeChat" class="stock-box-chat" :time="kLineActValue" />
		</div>
		<!-- 遮罩 -->
		<transition name="el-fade-in">
			<div class="mask-box" ref="maskBox" v-show="infoShow" @click="handleShowStockInfo"></div>
		</transition>
	</div>
</template>

<script setup>
import KChart from '@/rebuild/materials/shared/quote/mobile/KChart.vue';
import MkChart from '@/rebuild/materials/shared/quote/mobile/MkChart.vue';
import TableTab from '@/rebuild/materials/shared/quote/mobile/TableTab.vue';
import QuoteHeader from '@/rebuild/materials/shared/quote/mobile/QuoteHeader.vue';
import { ref, onMounted, computed } from 'vue';
import { useModuleData } from '@/rebuild/hooks/data/useModuleData';
import { useModuleConfig } from '@/rebuild/hooks/data/useModuleConfig';
import { useKLineTabs } from '@/rebuild/materials/shared/quote/useKLineTabs';

const { config, loadModuleConfig } = useModuleConfig();
const isKType = computed(() => {
	return config.value.displayForm == 1 || !config.value.displayForm;
});

onMounted(() => {
	fetchStockQuote();
	loadModuleConfig('quote');
});

const stockQuoteData = ref({});

const { quote } = useModuleData();
const fetchStockQuote = async () => {
	await quote.refresh();
	stockQuoteData.value = quote.data?.data || {};
};

const quoteBox = ref(null);
const maskBox = ref(null);
const infoShow = ref(false);

// 处理 QuoteHeader 组件的 toggleInfo 事件
const handleToggleInfo = show => {
	infoShow.value = show;
	if (maskBox.value && quoteBox.value) {
		maskBox.value.style.top = quoteBox.value.offsetTop + 'px';
	}

	// 控制移动端滚动
	const mobileScroll = document.querySelector('.mobile-module-scroll');
	if (mobileScroll) {
		mobileScroll.style.overflow = show ? 'hidden' : 'scroll';
	}
};

const quoteHeaderRef = ref(null);

// 处理显示/隐藏股票信息
const handleShowStockInfo = () => {
	if (maskBox.value && quoteBox.value) {
		maskBox.value.style.top = quoteBox.value.offsetTop + 'px';
	}
	infoShow.value = !infoShow.value;
	quoteHeaderRef.value && quoteHeaderRef.value.handleShowStockInfo();
	if (document.querySelector('.mobile-module-scroll'))
		document.querySelector('.mobile-module-scroll').style.overflow = infoShow.value ? 'hidden' : 'scroll';
};

const { kLineActValue, kLineTabList, changeTab } = useKLineTabs();
</script>

<style lang="less" scoped>
.quote-box {
	position: relative;
	width: 100%;
	padding-top: 90px;
	background: #f2f3f5;

	.echart-wrap {
		width: 100%;
		background: #fff;
	}
}

.mask-box {
	position: fixed;
	left: 0;
	right: 0;
	top: 0;
	bottom: 0;
	background: rgba(0, 0, 0, 0.5);
	z-index: 10;
}

.k-line-tab {
	padding: 8px 16px;
	display: flex;
	gap: 24px;
	span {
		position: relative;
		color: var(--t-secondary-color, #4e5969);
		font-size: 14px;
		font-weight: 400;
		line-height: 16px; /* 133.333% */
		letter-spacing: 2px;
	}
	.tab-active {
		color: var(--t-emphasis-color, #1d2129);
		font-weight: 600;
		&::before {
			content: '';
			width: 8px;
			height: 2px;
			border-radius: 8px;
			background: var(--t-emphasis-color, #1d2129);
			position: absolute;
			bottom: -2px;
			left: 50%;
			margin-left: -4px;
		}
	}
}

.stock-table-wrap {
	margin-top: 4px;
	padding: 20px 14px 20px;
	background: #fff;
}
</style>
